import React from 'react';
import clsx from 'clsx';
import styles from './RangeValue.module.scss';

const RangeValue = ({
  value,
  unit,
  className,
}) => {
  return (
    <span
      className={clsx(styles.root, className)}
      aria-live="polite"
    >
      <span className={styles.value}>{value}</span>
      {unit && <span className={styles.unit}>{unit}</span>}
    </span>
  );
};

export default RangeValue;
